import { useEffect, useState } from "react";
import { motion, useReducedMotion } from "framer-motion";
import { Megaphone, MonitorSmartphone, UserPlus, Sparkles, Database, TrendingUp } from "lucide-react";
import { useLang } from "@/i18n/LangContext";

const icons = [Megaphone, MonitorSmartphone, UserPlus, Sparkles, Database, TrendingUp];

export default function LeadFlowHero() {
  const { t } = useLang();
  const reduce = useReducedMotion();
  const labels = t("hero.flowLabels");
  const [active, setActive] = useState(0);

  useEffect(() => {
    if (reduce) return;
    const id = setInterval(() => setActive((a) => (a + 1) % 6), 1500);
    return () => clearInterval(id);
  }, [reduce]);

  return (
    <div data-testid="hero-lead-flow" className="relative mx-auto w-full max-w-[340px]">
      <div className="absolute left-[27px] top-6 bottom-6 w-px bg-gradient-to-b from-dblue/60 via-electric/40 to-dblue/60" />
      {!reduce && (
        <motion.div
          className="absolute left-[23px] h-2.5 w-2.5 rounded-full bg-electric shadow-[0_0_16px_rgba(33,167,255,0.9)]"
          animate={{ top: `${(active / 5) * 88 + 4}%` }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        />
      )}
      <div className="relative flex flex-col justify-between gap-5">
        {labels.map((label, i) => {
          const Icon = icons[i];
          const isActive = i === active;
          return (
            <div key={label} className="flex items-center gap-4">
              <div
                className={`relative z-10 flex h-14 w-14 items-center justify-center rounded-2xl border transition-[background-color,border-color,box-shadow] duration-500 ${
                  isActive
                    ? "border-electric/60 bg-gradient-to-br from-dblue to-electric shadow-[0_0_28px_rgba(20,110,245,0.5)]"
                    : "border-white/10 bg-ink2"
                }`}
              >
                <Icon className={`h-5 w-5 transition-colors duration-500 ${isActive ? "text-white" : "text-steel"}`} />
                {isActive && !reduce && <span className="absolute inset-0 rounded-2xl border border-electric/50 animate-ping-slow" />}
              </div>
              <div>
                <p className={`font-display text-sm font-bold tracking-wide transition-colors duration-500 ${isActive ? "text-white" : "text-steel"}`}>
                  {t(`hero.flow.${i}`)}
                </p>
                <p className={`text-xs transition-colors duration-500 ${isActive ? "text-electric" : "text-steel/50"}`}>{label}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
